/**
 * Embed-mode flag (ADR-034 H4).
 *
 * The search widget's component tree is shared: the booking results page renders the same
 * `SearchWidgetMain` as the third-party embed. Some of its behaviour is only safe when the
 * widget owns the page — most importantly, redirecting `window.location` on a GraphQL error.
 * On the engine's own domain that is a sensible fallback; on a hotel's page it navigates the
 * HOTEL'S visitors off the hotel's site, which is a far worse host-page mutation than the style
 * leak this embed exists to fix.
 *
 * A module-level flag rather than a React context: the consumers are a mix of components and
 * module-scope code, and threading a provider through the whole closure would mean editing far
 * more booking-flow files than the two ADR-034 sanctions.
 *
 * Default is `false`, so the standalone app and the booking flow behave exactly as before —
 * only `src/embed.tsx` ever sets it.
 */
let embedded = false

/** Called once by src/embed.tsx, before the widget renders. */
export function markAsEmbedded(): void {
  embedded = true
}

/** True only inside the third-party embed. False in the standalone app and the booking flow. */
export function isEmbedded(): boolean {
  return embedded
}

/**
 * Test-only. Jest isolates modules per FILE, not per `describe`, so a suite that flips this flag
 * would otherwise leak the embed behaviour into every test after it in the same file.
 */
export function __resetEmbedModeForTests(): void {
  embedded = false
}
